import type { SVGProps } from 'react';
const DawnFlagDK = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-DK_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-DK_svg__a)">
      <path
        fill="#EF264D"
        fillRule="evenodd"
        d="M2 0a2 2 0 0 0-2 2v4.4h6.286V0zm7.429 0v6.4H22V2a2 2 0 0 0-2-2zM22 9.6H9.429V16H20a2 2 0 0 0 2-2zM6.286 16V9.6H0V14a2 2 0 0 0 2 2z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagDK;
